export class CostCenter
{
    CostCenter!: string;
    CostCenterDesc!: string;
    CompanyCode!: string;
    Area_CODE!: string;
    Area_description!: string;
    Division!: string;
}